module.exports = __webpack_public_path__ + "static/media/gokrisp-features-mobile.e8f806fb.jpg";